import type { RouteObject } from "react-router-dom";
import { lazy } from "react";

const AdminLayout = lazy(() => import("../layouts/AdminLayout"));

// AdminLayout 이 내부에서 useRoutes 로 sub-route 매칭을 처리한다.
// (탭 전환 시 displayedLocation 기반 애니메이션을 위해 라우트 매칭을 layout 내부로 위임)
const routes: RouteObject[] = [
  {
    path: "*",
    element: <AdminLayout />,
  },
];

export default routes;
